import React from 'react';
import { Layers, Factory, DraftingCompass, ShieldCheck, HardHat, FileText, Headphones, Package, MapPin } from 'lucide-react';

const advantages = [
  { icon: Layers, title: 'Complete Turnkey Solutions', desc: 'Water treatment, filling, blowing and packaging delivered as one integrated, single-responsibility project.' },
  { icon: Factory, title: 'Engineering & Fabrication Capability', desc: 'In-house design, sheet fabrication and assembly at our Jaipur facility — we build what we sell.' },
  { icon: DraftingCompass, title: 'Customized Plant Design', desc: 'Layouts and machinery engineered to your building, water report and product mix — not off-the-shelf.' },
  { icon: ShieldCheck, title: 'Quality Machinery', desc: 'SS 304 food-grade contact parts, PLC controls and factory testing before every dispatch.' },
  { icon: HardHat, title: 'Professional Installation', desc: 'Our own engineers handle erection, piping, electricals and line balancing at your site.' },
  { icon: FileText, title: 'Documentation & Technical Support', desc: 'BIS/FSSAI-ready layouts, machinery documentation, lab lists and audit preparation.' },
  { icon: Headphones, title: 'After-Sales Service', desc: 'Responsive breakdown support with documented SOPs and operator retraining when you need it.' },
  { icon: Package, title: 'Spare Parts & AMC Support', desc: 'Genuine spares off the shelf and structured AMC plans that keep plants running.' },
  { icon: MapPin, title: 'PAN India Project Execution', desc: 'Installations and service delivered across India — from Rajasthan to the North-East.' }
];

export const WhyAldenSection = () => (
  <section className="py-16 md:py-20 bg-alden-navy" data-testid="why-alden-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <div className="text-sm font-bold text-emerald-400 uppercase tracking-widest mb-2">Why Alden</div>
        <h2 className="text-3xl md:text-4xl font-bold text-white">Practical Advantages, Not Marketing Claims</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {advantages.map((a) => (
          <div key={a.title} className="bg-white/5 border border-white/10 hover:border-alden-green rounded-xl p-6 transition-colors" data-testid="why-alden-card">
            <a.icon className="w-8 h-8 text-emerald-400 mb-4" />
            <h3 className="font-bold text-white mb-2">{a.title}</h3>
            <p className="text-sm text-white/70 leading-relaxed">{a.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyAldenSection;
